import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=50ee2540&scoped=true&"
import script from "./ProductAdd.vue?vue&type=script&lang=ts&"
export * from "./ProductAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAdd.vue?vue&type=style&index=0&id=50ee2540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ee2540",
  null
  
)

export default component.exports